import React, { useEffect } from 'react';
import loadable from '@loadable/component';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import NotFoundPage from '../../containers/NotFoundPage/NotFoundPage';
import { fetchStoresLean } from '../../ducks/user.duck';
import { setDOMLoaded, setFirstLoaded } from '../../ducks/ui.duck';
const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

export const CMSPageComponent = props => {
  const {
    params,
    pageAssetsData,
    inProgress,
    error,
    currentUser,
    listings,
    stores,
    domLoaded,
  } = props;
  const pageId = params.pageId || props.pageId;

  if (!inProgress && error?.status === 404) {
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  useEffect(() => {
    props.handleDomLoaded();
  }, []);

  useEffect(() => {
    if (domLoaded && (listings || []).length && !props.firstLoaded) {
      props.handleFirstLoaded();
      props.handleStores();
    }
  }, [domLoaded]);

  return (
    <PageBuilder
      pageAssetsData={pageAssetsData?.[pageId]?.data}
      inProgress={inProgress}
      schemaType="Article"
      currentUser={currentUser}
      listings={listings}
      stores={stores}
    />
  );
};

CMSPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
};

const mapStateToProps = state => {
  const { currentUser, stores } = state.user;
  const { domLoaded, firstLoaded } = state.ui;
  const { pageAssetsData, inProgress, error, listings } = state.hostedAssets || {};
  return {
    pageAssetsData,
    inProgress,
    error,
    currentUser,
    listings,
    stores,
    domLoaded,
    firstLoaded,
  };
};

const mapDispatchToProps = dispatch => ({
  handleDomLoaded: () => dispatch(setDOMLoaded()),
  handleFirstLoaded: () => dispatch(setFirstLoaded()),
  handleStores: () => dispatch(fetchStoresLean()),
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const CMSPage = compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(CMSPageComponent);

export default CMSPage;
